<template>
  <b-columns is-multiline>
    <b-column v-if="loadingObservations">
      <loading-spinner
        size="3x"
      />
    </b-column>
    <b-column
      class="is-full"
      v-for="(category, idx) in categories"
      :key="idx"
    >
      <observation-category
        :name="category | capitalizeFirstLetter"
        :options="getOptions(category)"
        :category-icon="getIcon(category)"
        :is-sub-categorized="category === 'symptoms'"
      />
    </b-column>
  </b-columns>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ObservationCategory from '@/components/observations/ObservationCategory'

const categoryNames = ['colors', 'tastes', 'odors', 'states', 'symptoms']
const categoryIcons = {
  colors: 'palette',
  tastes: 'times',
  odors: 'wind',
  states: 'splotch',
  symptoms: 'comment-medical',
}

export default {
  components: {
    ObservationCategory
  },
  created () {
    this.fetchObservations()
  },
  computed: {
    ...mapGetters(['loadingObservations'].concat(categoryNames)),
    categories () {
      return categoryNames
    },
  },
  methods: {
    ...mapActions(['fetchObservations']),
    getOptions (name) {
      return this[name]
    },
    getIcon (name) {
      return categoryIcons[name]
    }
  }
}
</script>
